import {
  Flexbox,
  Form,
  ListManager,
  Paginator,
  QuickFilter,
} from '@/components'
import { textClasses } from '@/constants/castration'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import { ANIMAL, CASTRATION } from '@/lib/enums'
import petisUsers from '@/services/api/petisUsers'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

function Castrations({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { id } = useParams()
  const history = useHistory()
  const { data, error, loading } = useAxiosRequest(
    petisUsers.castrations,
    id,
    query,
  )

  const rows = data?.rows || []

  return (
    <div className="modal active" id="modal-id">
      <a
        type="button"
        className="modal-overlay"
        aria-label="Close"
        onClick={() => history.goBack()}
      />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={() => history.goBack()}
          />
          <div className="modal-title h5">Castrações por categoria</div>
          <cite>
            Lista de todas as categorias de castrações, com o número total em
            cada uma
          </cite>
        </div>
        <div className="modal-body">
          <div className="content">
            <QuickFilter
              initialValues={{
                createdAt_between: [],
              }}
              title="Filtrar por data de solicitação"
              renderForm={({ values, setFieldValue }) => (
                <>
                  <Flexbox.Column className="col-4 pt-2">
                    <Form.Group>
                      <Form.Label
                        className="label-sm pt-2"
                        htmlFor="createdAt_between"
                      >
                        Data da solicitação
                      </Form.Label>
                      <Form.DatePickerField
                        placeholderText="De - Até"
                        dateFormat="dd/MM/yyyy"
                        startDate={
                          values.createdAt_between[0]
                            ? new Date(values.createdAt_between[0])
                            : null
                        }
                        endDate={
                          values.createdAt_between[1]
                            ? new Date(values.createdAt_between[1])
                            : null
                        }
                        selectsEnd
                        className="form-input input-sm"
                        selectsRange
                        isClearable
                        name="createdAt_between"
                        onChange={(v) => {
                          const [start, end] = v || []
                          if (!start && !end) setFieldValue('createdAt_between', [])

                          const formattedValues = []
                          if (start) formattedValues.push(start)
                          if (end) formattedValues.push(new Date(end.setUTCHours(23, 59, 59, 999)))

                          setFieldValue('createdAt_between', formattedValues)
                        }}
                      />
                    </Form.Group>
                  </Flexbox.Column>
                </>
              )}
            />
            <ListManager
              emptyMessage="Esse usuário não possui castrações vinculadas"
              emptyIcon="fas fa-cut"
              loading={loading}
              count={data?.rows?.length || 0}
              error={error}
            >
              <>
                <table className="table text-small table-striped table-hover">
                  <thead>
                    <tr>
                      <th width={300}>Gênero</th>
                      <th width={300}>Status</th>
                      <th width={300}>Espécie</th>
                      <th className="text-right" width={100}>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((castration) => (
                      <tr
                        key={`${castration?.gender}-${castration?.status}
                    -${castration?.categoryDescription}`}
                      >
                        <td>{ANIMAL.gender.t(castration?.gender)}</td>
                        <td className={textClasses[castration?.status]}>
                          {CASTRATION.status.t(castration?.status)}
                        </td>
                        <td>{castration?.categoryDescription}</td>
                        <td className="text-right">{castration?.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {Boolean(data) && (
                  <div className="my-2">
                    {Boolean(data) && <Paginator paginatedList={data} />}
                  </div>
                )}
              </>
            </ListManager>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Castrations
